import React from 'react';
import {
  Box,
  Container,
  Typography,
  Link,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        py: { xs: 2, sm: 3 },
        px: { xs: 1.5, sm: 2 },
        mt: 'auto',
        backgroundColor: 'background.paper',
        borderTop: 1,
        borderColor: 'divider',
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: { xs: 1.5, sm: 2 },
          }}
        >
          {/* Copyright */}
          <Typography
            variant="body2"
            color="text.secondary"
            align="center"
            sx={{
              fontSize: { xs: '0.75rem', sm: '0.875rem' },
              order: { xs: 2, sm: 1 },
            }}
          >
            © {year} Flex PoS. All rights reserved.
          </Typography>

          {/* Links */}
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
              gap: { xs: 1.5, sm: 3 },
              order: { xs: 1, sm: 2 },
              '& > a': {
                color: 'text.secondary',
                textDecoration: 'none',
                fontSize: { xs: '0.75rem', sm: '0.875rem' },
                transition: 'color 0.2s ease-in-out',
                whiteSpace: 'nowrap',
                '&:hover': {
                  color: 'primary.main',
                },
              },
            }}
          >
            <Link component={RouterLink} to="/terms?tab=privacy" variant="body2">
              Privacy Policy
            </Link>
            <Link component={RouterLink} to="/terms" variant="body2">
              Terms of Service
            </Link>
            <Link component={RouterLink} to="/contact" variant="body2">
              Contact
            </Link>
          </Box>

          {/* Version */}
          <Typography
            variant="body2"
            color="text.secondary"
            align="center"
            sx={{
              fontSize: { xs: '0.7rem', sm: '0.75rem' },
              order: 3,
            }}
          >
            Version 1.0.0
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
